import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a99b44d86bf030014c370c0_1788479730281_c3fdcde1/fable/src/app/page.tsx");
